/**
 * get-initials.ts
 *
 * Utilidad para extraer iniciales de un nombre.
 * Usada en avatares de usuario, proyecto y organización.
 */

/**
 * Extrae las iniciales de un nombre completo o nombre de entidad.
 *
 * Reglas:
 * - 1 palabra  → primera letra
 * - 2+ palabras → primera letra de la primera y última palabra
 * - Máximo 2 caracteres siempre
 * - Resultado en mayúsculas
 *
 * @param name - Nombre completo o nombre de entidad
 * @returns Iniciales en mayúsculas (1–2 caracteres)
 *
 * @example
 * getInitials("Guillermo Sandoval") // → "GS"
 * getInitials("Proyecto Alpha")     // → "PA"
 * getInitials("Innovaforce")        // → "IN"
 * getInitials("")                   // → "?"
 */
export function getInitials(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "?";

  const words = trimmed.split(/\s+/).filter(Boolean);

  if (words.length === 1) {
    return words[0].substring(0, 2).toUpperCase();
  }

  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}
